import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

// Único ponto do sistema que deve importar @tippyjs/react diretamente - todo
// tooltip passa por aqui (ver pages/nova-farm/weather-traffic-light/index.js
// pro caso com theme="tooltip").
// Padrão "light" (bolha escura/texto branco) - é o tema que a grande maioria
// das chamadas já usava antes dessa migração. O tema "tooltip" (branco/texto
// escuro, ver styles/global.js) existe à parte e precisa ser passado
// explicitamente (theme="tooltip") por quem quiser esse visual invertido.
const Tooltip = ({
  children,
  animation = "fade",
  arrow = true,
  delay = [100, 100],
  placement = "top",
  theme = "light",
  ...rest
}) => (
  <Tippy
    animation={animation}
    arrow={arrow}
    delay={delay}
    placement={placement}
    theme={theme}
    {...rest}
  >
    {children}
  </Tippy>
);

export default Tooltip;
